import * as React from "react";
import Routes from "security-app/routing/Routes";
import useUserDateTime from "hooks/useUserDateTime";
import { useGetInvestigations } from "security-app/hooks/useInvestigationsAPI";
import NumberCard from "./NumberCard";
const ARCHIVED = false;
function InvestigationsCounter() {
  const { userTimezone } = useUserDateTime();
  const {
    pagination: { total }
  } = useGetInvestigations({ page: 1, perPage: 1 }, ARCHIVED, userTimezone);
  const {
    pagination: { total: closed }
  } = useGetInvestigations(
    {
      page: 1,
      perPage: 1,
      filters: { status: [{ label: "Closed", value: "Closed", type: "string" }] }
    },
    ARCHIVED,
    userTimezone
  );
  return /* @__PURE__ */ React.createElement(
    NumberCard,
    {
      value: total.toString(),
      label: "Total investigations",
      subLabel: `${closed} closed`,
      replayLink: Routes.INVESTIGATIONS.LIST
    }
  );
}
export default InvestigationsCounter;
